import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomEditCard from '../../../common/components/CustomEditCard/CustomEditCard';
import _ from 'lodash';
import WarningContent from './WarningContent';
import { warningcomplaintService } from '../../../api/services/warningcomplaintService';
import { useAppSelector } from '../../../infra/hooks';
import ComplaintContent from './ComplaintContent';
interface propsType {
  trans?: any;
  complaintListData: any;
  removeID: (id: string) => void;
}
const Complaint: React.FC<propsType> = ({
  trans,
  complaintListData,
  removeID,
}) => {
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state);
  const EmpID = selector.authSlice.emp_id;
  const CompanyID = selector.authSlice.company_id;
  const onClickAccept = async (id: any) => {
    const payload = {
      id: id,
      empId: EmpID,
      companyId: CompanyID,
      empStatus: 'Accept',
    };
    await warningcomplaintService
      .updateEmpComplaintStatus(payload)
      .then((res) => {
        if (res?.response) {
          removeID(id);
        }
      })
      .catch((err) => {
        return;
      });
  };
  const onClickReject = async (id: any) => {
    const payload = {
      id: id,
      empId: EmpID,
      companyId: CompanyID,
      empStatus: 'Reject',
    };
    await warningcomplaintService
      .updateEmpComplaintStatus(payload)
      .then((res) => {
        if (res?.response) {
          removeID(id);
        }
      })
      .catch((err) => {
        return;
      });
  };
  return (
    <div>
      <CustomEditCard
        card_title={trans('Complaint')}
        card_height="380px"
        //onClick={() => setOpenModal(true)}
        showEditButton={false}
      >
        {_.map(complaintListData, (data: any) => {
          return (
            <ComplaintContent
              taxName={data?.subject}
              complaintBy={data?.complaint_by_name}
              description={data?.description}
              onClickAccept={() => {
                onClickAccept(data?.id);
              }}
              onClickReject={() => {
                onClickReject(data?.id);
              }}
            />
          );
        })}
      </CustomEditCard>
    </div>
  );
};
export default Complaint;
